<!--申请省级鉴定企业及产品-->
<template>
  <div class="location-number">
    <seamless-scroll
      class="locaiton-scroll"
      :data='qualificationList'
      :class-option="classOption"
    >
      <div
        class="item-class"
        v-for="(item,index) in qualificationList"
        :key="index"
      >
        <div class="first-row">
          <img :src="require(`@/assets/images/governmentAffairs/vehicleIdentify/icon_cp_${item.statusCode}.png`)" class="status-img"/>
          <img :src="require(`@/assets/images/governmentAffairs/vehicleIdentify/icon_cp_${item.typeCode}.png`)" class="status-type" :class="{'status-type-two': item.typeCode != 'gt' && item.typeCode != 'st'}"/>
          <div class="row-name">{{item.number}}</div>
        </div>
        <div class="second-row">{{item.productModel}}</div>
        <div class="third-row">{{item.enterpriseName}}</div>
      </div>
    </seamless-scroll>
  </div>
</template>

<script>
export default {
  props: {
    qualificationList: {
      type: Array,
      default: [],
    }
  },
  data() {
    return {
      classOption: {
        step: 0.5,
        limitMoveNum: 3
      },
 
    }
  },
  methods: {
 
  },
}
</script>
<style lang='scss' scoped>
@function vw($px) {
  @return ($px / 1920) * 100vw;
}
@function vh($px) {
  @return ($px / 1080) * 100vh;
}
@function fontSize($px) {
  @return 100vw * $px / 1920;
}

.location-number {
  height: 100%;
  font-family: Microsoft YaHei;
  .locaiton-scroll {
    height: 100%;
    overflow: hidden;
  }
  .item-class {
    position: relative;
    width: vw(314);
    height: vh(75);
    padding: vh(6) vw(15);
    margin-top: vh(7);
    background-image: url("../../../../assets/images/governmentAffairs/vehicleIdentify/bg_list_jdqy.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    font-size: fontSize(14);
    color: #DEFFE9;
    .first-row {
      display: flex;
      padding-bottom: vh(5);
      border-bottom: 1px dashed #0D7330;
      .status-img {
        width: vw(38);
        height: vh(19);
        margin-right: vw(8);
      }
      .status-type {
        width: vw(38);
        height: vh(19);
      }
      .status-type-two {
        width: vw(66);
        height: vh(19);
      }
      .row-name {
        margin-left: vh(6);
        padding-right: vh(8);
        font-weight: bold;
        font-style: italic;
        background: linear-gradient(180deg, #FFFFFF 35.009765625%, #BDFFCC 70%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
 
    } 
    .second-row {
      margin-top: vh(2);
    }
    .third-row {
      max-width: vw(278);
      white-space: nowrap; /* 防止换行 */
      overflow: hidden; /* 隐藏超出部分 */
      text-overflow: ellipsis; /* 显示省略号 */
    }

  }
 
 
}
</style>
